import React, { useContext, useEffect, useRef, useState } from 'react'
import { WrapperContext } from '../../../interfaces/contexts'

import './index.scss'

import pages from '../../../data/images.json'
import dataPages from '../../../data/data.json'
import locations from '../../../data/location.json'
import pageColors from '../../../data/colors.json'
import { Badge, Modal, Whisper, Tooltip } from 'rsuite'
import Slider from 'react-slick'

const Container = ({ className = '', options = {}, style = {}, children }) => {
  const $ = window.jQuery

  useEffect(() => {
    const flipBook = $('#flip-book')
    if (flipBook) {
      flipBook.turn(Object.assign({}, options))
    }
    document.addEventListener('keydown', handleKeyDown, false)

    return () => {
      const flipBook = $('#flip-book')
      if (flipBook) {
        $(flipBook).turn('destroy').remove()
      }
      document.removeEventListener('keydown', handleKeyDown, false)
    }
  }, [])

  const handleKeyDown = (event) => {
    if (event.keyCode === 37) {
      $('#flip-book').turn('previous')
    }
    if (event.keyCode === 39) {
      $('#flip-book').turn('next')
    }
  }

  return (
    <div id="flip-book" className={className} style={Object.assign({}, style)}>
      {children}
    </div>
  )
}

const helpStyles = [
  {
    shadow: {
      width: '5rem',
      height: '5rem',
      bottom: 0,
      left: 0,
    },
    image: {
      width: '5rem',
      height: '5rem',
      bottom: '2.5rem',
      left: '5rem',
    },
  },
  {
    shadow: {
      width: '5rem',
      height: '5rem',
      bottom: 0,
      left: 0,
    },
    image: {
      width: '5rem',
      height: '5rem',
      bottom: '2.5rem',
      left: '5rem',
    },
  },
  {
    shadow: {
      width: '5rem',
      height: '5rem',
      bottom: 0,
      left: 0,
    },
    image: {
      width: '5rem',
      height: '5rem',
      bottom: '2.5rem',
      left: '5rem',
    },
  },
]

const instructionText = ['Nhấn giữ ngay góc trang và kéo chuột để lật trang']

export const Turn = () => {
  const { initModal, carts, initDrawer } = useContext(WrapperContext)
  const [showHelp, setShowHelp] = useState(false)
  const [helpIndex, setHelpIndex] = useState(0)

  const currentPage = useRef(null)

  const $ = window.jQuery

  const body = document.querySelector('body')
  const defaultWidth = body.clientWidth
  const defaultHeight = body.clientHeight

  const options = {
    width:
      defaultWidth < defaultHeight
        ? (576 / 762) * 0.8 * defaultHeight
        : (576 / 762) * 0.9 * defaultHeight * 2,
    height:
      defaultWidth < defaultHeight ? 0.8 * defaultHeight : 0.9 * defaultHeight,
    autoCenter: false,
    display: defaultWidth < defaultHeight ? 'single' : 'double',
    acceleration: true,
    elevation: 100,
    gradients: !$().isTouch,
    when: {
      turned: function (e, page) {
        let pageIndex = page - 2
        if (pageIndex < 1) {
          currentPage.current.value = 1
        } else {
          currentPage.current.value = pageIndex
        }
      },
    },
  }

  const slickSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const onTextChangePage = (e) => {
    if (e.key != 'Enter') return
    try {
      let pageIndex = parseInt(e.target.value)
      if (pageIndex < 1) pageIndex = 1
      $('#flip-book').turn('page', pageIndex + 2)
      currentPage.current.value = pageIndex
    } catch {}
  }

  const onTextFocus = (e) => {
    e.target.selectionStart = 0
    e.target.selectionEnd = e.target.value.length
  }

  const handleResize = (e) => {
    const currentWidth = body.clientWidth
    const currentHeight = body.clientHeight
    $('#flip-book')
      .turn(
        'size',
        currentWidth < currentHeight
          ? (576 / 762) * 0.8 * currentHeight
          : (576 / 762) * 0.9 * currentHeight * 2,
        currentWidth < currentHeight ? 0.8 * currentHeight : 0.9 * currentHeight
      )
      .turn('display', currentWidth < currentHeight ? 'single' : 'double')
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div
      className="t-turn"
      style={{ backgroundImage: `url('/images/bg/bg-main.jpg')` }}
    >
      <Container options={options} className="magazine">
        {pages.map((page, index) => (
          <div key={index} className="__page">
            <div className="__image-container">
              <img className="__main-image" src={page} alt={'page ' + index} />
              {locations[index] && (
                <div
                  className="__table-shadow"
                  style={{
                    width: locations[index][2],
                    height: locations[index][3],
                    top: locations[index][1],
                    left: locations[index][0],
                  }}
                  onClick={(e) => {
                    const pageIndex = index - 1
                    console.log('pageIndex', pageIndex)
                    e.stopPropagation()
                    initModal.setState({
                      id: 'table-modal',
                      list: dataPages.filter((item) => {
                        return item.pageIndex == pageIndex
                      }),
                      color: pageColors.find(
                        (m) => m.from <= pageIndex && pageIndex <= m.to
                      )?.color,
                    })
                  }}
                />
              )}
            </div>
          </div>
        ))}
      </Container>
      <div className="__page-group">
        <span style={{ color: 'white' }}>Trang </span>
        <input
          ref={currentPage}
          onKeyPress={onTextChangePage}
          onFocus={onTextFocus}
          style={{ width: '30px', textAlign: 'center' }}
        />
        <span style={{ color: 'white' }}> / {pages.length - 2}</span>
      </div>
      <div className="__direction-group">
        <Whisper
          placement="bottom"
          trigger="hover"
          speaker={<Tooltip>Hướng dẫn sử dụng</Tooltip>}
        >
          <img
            src="/images/icons/ic-help.png"
            width="40"
            height="40"
            style={{ marginRight: '10px' }}
            onClick={() => {
              setShowHelp(true)
            }}
          />
        </Whisper>
        <Whisper
          placement="bottom"
          trigger="hover"
          speaker={<Tooltip>Giỏ hàng</Tooltip>}
        >
          <Badge
            className="btn-cart-badge"
            content={carts.state?.length ?? 0}
            onClick={() => {
              initDrawer.setState({ isShow: true })
            }}
          >
            <img src="/images/icons/ic-cart.png" width="40" height="40" />
          </Badge>
        </Whisper>
      </div>
      <Modal
        backdropClassName={'t-modal-help-backdrop'}
        className={'t-modal-help'}
        size="xs"
        show={showHelp}
        onHide={() => {
          setShowHelp(false)
          setHelpIndex(0)
        }}
      >
        <div
          className="__instruction"
          data-index="1"
          style={{ display: helpIndex === 0 ? 'block' : 'none' }}
        >
          <div className="__pointer">
            <img src="/images/icons/handIcon.png" alt="" />
          </div>
          <div className="__text">
            Nhấn giữ ngay góc trang và kéo chuột để lật trang
          </div>
        </div>
        <div
          className="__instruction"
          data-index="2"
          style={{ display: helpIndex === 1 ? 'block' : 'none' }}
        >
          <div className="__pointer">
            <img src="/images/icons/handIcon.png" alt="" />
          </div>
          <div className="__text">Click table để xem chi tiết</div>
        </div>
        <div
          className="__instruction"
          data-index="3"
          style={{ display: helpIndex === 2 ? 'block' : 'none' }}
        >
          <div className="__pointer">
            <img src="/images/icons/handIcon.png" alt="" />
          </div>
          <div className="__text">
            Click section chứa sản phẩm để xem chi tiết
          </div>
        </div>
        <Slider
          className="custom-carousel"
          {...slickSettings}
          afterChange={(index) => setHelpIndex(index)}
        >
          <img src="/images/helps/help-1.png" className="img-help" />
          <img src="/images/helps/help-2.png" className="img-help" />
          <img src="/images/helps/help-3.png" className="img-help" />
        </Slider>
      </Modal>
    </div>
  )
}
